import { PropertyWrite } from "@angular/compiler";
import { Observable } from "rxjs/Observable";

export const StatusMap = {
    assigned: 'Assigned',
    unassigned: 'Unassigned',
    sent_to_editor: 'Sent to Editor',
    revision_requested: 'Revision Requested',
    add_assigned: 'Page Additions Assigned',
    add_sent_to_editor: 'Page Additions Sent to Editor',
    imported: 'Imported',
    publish: 'Published',
    cloned: 'Copy Ready',
    publish_ready: 'Ready to Publish'
}

export class Assignment {
    abbreviation = '';
    articleTitle = '';
    categories = [];
    childType = 'slideshow';
    clones = '';
    cloneMaster = 0;
    dmc = 0;
    dueDate = '';
    editor = 0;
    editorQueue = false;
    hidePost = '';
    intro = true;
    introWordCount = 100;
    importBlogId = 0;
    importPostId = 0;
    metaDescription = '';
    metaTitle = '';
    ogDescription = '';
    ogImage = '';
    ogTitle = '';
    narrative = false;
    n2s = false;
    outro = false;
    outroWordCount = 100;
    pageAddDate = '';
    pageAddWriter = 0;
    previousStatus = '';
    primarySite = 0;
    priority = 1;
    published = false;
    publishDate = '';
    quizType = '';
    reference = '';
    sites = [];
    siteCategorySearch = '';
    slideCount = 20;
    slides = '';
    slideWordCount = 100;
    slug = '';
    status = 'unassigned';
    targetPublishDate = '';
    taxonomies = {};
    taxonomySearch = '';
    team = [];
    title = '';
    type = 'assignments';
    writer = 0;

    constructor(args) {
        for(var i in args) {
            this[i] = args[i];
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/assignments/assignment.model.ts